export const ALERT_INFO = 'alert_info'
export const ALERT_ERROR = 'alert_error'
export const ALERT_EMPTY = 'alert_empty'

export const USER_INIT_USERDATA = 'user__init_userdata'
export const USER_REFRESH_USERDATA = 'user__refresh_userdata'
export const USER_REFRESH_NOTIFICATIONS = 'user__refresh_notifications'

export const FINANCE_REFRESH_RATE = 'finance__refresh_spd_rate'

export const REGISTRATION_FILL_DATA = 'registration__fill_data'



// WEBPACK FOOTER //
// ./src/store/mutations.js